import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import Layout from "../components/layout";
import Breadcrumb from '../components/breadcrumb';
import '../components/standings/_standings.scss';
import YearSelect from '../components/year-selector';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

const Standings = (query) => {
  // Get GraphlQL data
  const games = query.data.allGamesJson.nodes;
  const owners = query.data.allOwnersJson.nodes;

  const options = {
    defaultSortName: 'rank',
    defaultSortOrder: 'asc'
  };

  const [yearLabels] = useState([...new Set(games.map(item => item.year))].reverse());
  const [statsByTeam, setStatsByTeam] = useState([]);
  const [year, setYear] = React.useState("All");
  const [playoff, setPlayoff] = useState(false);
  const [regular, setRegular] = useState(true);

  useEffect(() => {
    const tempStatsByTeam = [];
    const gamesByOwner = [];
    let filteredGames = games;
		let teamObject = [];

    if (!playoff) {
      filteredGames = filteredGames.filter(function (game) {
        return game.playoffTierType !== "WINNERS_BRACKET";
      });            
    }  
    
    if (!regular) {
      filteredGames = filteredGames.filter(function (game) {
        return game.playoffTierType !== "NONE";
      });            
    } 
    
    if (year !== 'All') {
      filteredGames = filteredGames.filter(function (game) {
        return game.year === parseInt(year);
      });
    }

    //get games by owner
    filteredGames.forEach((game) => {
      if (gamesByOwner.find(obj => obj.id === game.team_a[0].ownerId)) {
          teamObject = gamesByOwner.find(obj => obj.id === game.team_a[0].ownerId);
          teamObject.games.push(game);
      } else {
        gamesByOwner.push({
          id: game.team_a[0].ownerId,
          name: game.team_a[0].owner,
          games: [game]
        })
      }
      if (gamesByOwner.find(obj => obj.id === game.team_b[0].ownerId)) {
          teamObject = gamesByOwner.find(obj => obj.id === game.team_b[0].ownerId);
          teamObject.games.push(game);
      } else {
        gamesByOwner.push({
          id: game.team_b[0].ownerId,
          name: game.team_b[0].owner,
          games: [game]
        })
      }
    })

    // process stats per team 
    gamesByOwner.forEach((team) => {
      let wins = 0,
        loses = 0,
        ties = 0,
        points = 0,
        pointsAgaisnt = 0;
      
      team.games.forEach((game) => {
        if(year === "All") {
          if(game.team_a[0].ownerId === team.id) {
            points += parseFloat(game.team_a[0].score);
            pointsAgaisnt += parseFloat(game.team_b[0].score);
          } else if (game.team_b[0].ownerId === team.id) {
            points += parseFloat(game.team_b[0].score);
            pointsAgaisnt += parseFloat(game.team_a[0].score);
          }

          if (
            (game.winner === 'HOME' && game.team_a['0'].ownerId === team.id) ||
            (game.winner === 'AWAY' && game.team_b['0'].ownerId === team.id)
          ) {
            wins++
          } else if (parseFloat(game.team_b[0].score) === parseFloat(game.team_a[0].score)) {
            ties++
          } else {
            loses++
          }
        } else {
          if (game.team_a[0].ownerId === team.id) {
            points += parseFloat(game.team_a[0].score);
            pointsAgaisnt += parseFloat(game.team_b[0].score);
          } else if (game.team_b[0].ownerId === team.id) {
            points += parseFloat(game.team_b[0].score);
            pointsAgaisnt += parseFloat(game.team_a[0].score);
          }
          if (
            (game.winner === 'HOME' && game.team_a['0'].ownerId === team.id) ||
            (game.winner === 'AWAY' && game.team_b['0'].ownerId === team.id)
          ) {
            wins++
          } else if (parseFloat(game.team_b[0].score) === parseFloat(game.team_a[0].score)) {
            ties++
          } else {
            loses++
          }
        }
      })
      let winRate = parseFloat(wins + (ties * .5))/team.games.length;

      // Get Owner name from Owners 
      let owner = {
        name: "Null Owner",
        fantasyname:"Empty Team"
      }
      owner = _.find(owners, ['id', team.id]) ? _.find(owners, ['id', team.id]) : owner;

      //console.log(team.id,"esto es team id ")

      //console.log(owner,"esto es owner")

      tempStatsByTeam.push({
        team: owner.fantasyname !== '' ? owner.name + " (" + owner.fantasyname + ")" : owner.name ,
        wins: wins,
        loses: loses,
        ties: ties,
        points: parseFloat(points.toFixed(2)),
        pointsAgainst: parseFloat(pointsAgaisnt.toFixed(2)),
        winRate: winRate.toFixed(3)
      })
    })

    // Sort by wins
    tempStatsByTeam.sort(function(a, b) {
      a = new Date(a.wins);
      b = new Date(b.wins);
      return a>b ? -1 : a<b ? 1 : 0;
    });

    // Set rank based on wins
    tempStatsByTeam.forEach((team, index) => {
      team.rank = index + 1;
    })

    setStatsByTeam(() => tempStatsByTeam);

  }, [year,playoff,regular,games,owners]);
  
	return (
    <Layout >
    <main className="container-fluid standings">
      <Breadcrumb title="Standings"/>
        <div className="card mb-3">
            <div className="card-header"> 
            <input type="checkbox" id="regular-season" value="regular-season" onChange={(e) => {setRegular(e.target.checked)}} checked={regular} /> <span className="checkbox-label">Regular Season</span>
						<input type="checkbox" id="playoffs" value="playoffs" onChange={(e) => {setPlayoff(e.target.checked)}} checked={playoff} /> <span className="checkbox-label">Playoffs</span>
   
          <br/><br/>
          
          <YearSelect data={yearLabels} change={(e) => {setYear( e.target.value)}}/>
              </div>
            <div className="card-body">
              <div className="table-responsive">
                <BootstrapTable data={statsByTeam} options={ options } bordered={ false } trClassName="alt" version='4'>
                  <TableHeaderColumn dataField='rank' isKey={true} dataSort={true} className="heading--gray" width="10%">Rank</TableHeaderColumn>
                  <TableHeaderColumn dataField='team' dataSort={ true } className="heading--gray">Team</TableHeaderColumn>
                  <TableHeaderColumn dataField='wins' dataSort={true}  className="heading--gray" width="10%">W</TableHeaderColumn>
                  <TableHeaderColumn dataField='loses' dataSort={true} className="heading--gray" width="10%">L</TableHeaderColumn>
                  <TableHeaderColumn dataField='ties' dataSort={true} className="heading--gray" width="10%">T</TableHeaderColumn>
                  <TableHeaderColumn dataField='winRate' dataSort={true} className="heading--gray" width="10%">PCT</TableHeaderColumn>
                  <TableHeaderColumn dataField='points' dataSort={true} className="heading--gray" width="10%">PF</TableHeaderColumn>
                  <TableHeaderColumn dataField='pointsAgainst' dataSort={ true } className="heading--gray" width="10%">PA</TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
            <div className="card-footer small text-muted"></div>
          </div>
    </main>
   </Layout>
	);
};

export default Standings;

export const pageQuery = graphql`
{
  allGamesJson {
    nodes {
      id
      year
      winner
      week
      playoffTierType
      team_a {
        logo
        name
        owner
        ownerId
        rank
        score
      }
      team_b {
        logo
        name
        owner
        ownerId
        rank
        score
      } 
    }
  }
  allOwnersJson {
    nodes {
      fantasyname
      id
      image
      name
      status
    }
  }
}
`;
